import { IonIcon } from '@ionic/react';
import { atOutline, closeOutline } from 'ionicons/icons';
import React from 'react';
import useAgentContextSources from '../../hooks/useAgentContextSources';
import { useIcons } from '../../hooks/useIcons';
import { AgentAttachedTrack } from './agentAttachedTrack';
import AgentContextPicker from './AgentContextPicker';

const TRIGGER_ID = 'agent-context-add';

/**
 * Context chips at the top of the composer. Attached sources show as chips;
 * track search lives behind the @ button and inserts into the draft text.
 */
export const AgentChatSources: React.FC<{
  disabled?: boolean;
  onInsertTrack: (track: AgentAttachedTrack) => void;
}> = ({ disabled, onInsertTrack }) => {
  const { sources, attach, detach, connectSource } = useAgentContextSources();
  const { icons } = useIcons();

  const attached = sources.filter(
    (source) => source.connected && source.attached,
  );

  return (
    <div className="agent-context-bar">
      <button
        id={TRIGGER_ID}
        type="button"
        className="agent-context-add"
        disabled={disabled}
        title="Search for a track or add a source"
      >
        <IonIcon icon={atOutline} />
        <span className="agent-context-add-label">@</span>
      </button>

      {attached.map((source) => (
        <span
          key={source.id}
          className="agent-context-chip"
          title={source.name}
        >
          <img
            src={icons[source.iconKey] || ''}
            alt=""
            className="agent-context-chip-icon"
            style={{ visibility: icons[source.iconKey] ? 'visible' : 'hidden' }}
          />
          <span className="agent-context-chip-label">{source.name}</span>
          <button
            type="button"
            className="agent-context-chip-remove"
            disabled={disabled}
            aria-label={`Remove ${source.name}`}
            onClick={() => detach(source.id)}
          >
            <IonIcon icon={closeOutline} />
          </button>
        </span>
      ))}

      <AgentContextPicker
        triggerId={TRIGGER_ID}
        sources={sources}
        onInsertTrack={onInsertTrack}
        onAttach={attach}
        onDetach={detach}
        onConnect={connectSource}
      />
    </div>
  );
};

export default AgentChatSources;
